<template>
  <div class="wrapper">
    <CRow class="mt-3">
      <CCol sm="12">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h4>Kids Moving Up Class</h4>
                <p class="text-muted mb-3">
                  Use this page to move kids to the next class. You can only move kids up one class each year. You can see details of the changes in the kid notes.
                </p>
                <div>
                  <button class="btn btn-primary mt-3" @click="submit" :disabled="submitting">Submit</button>
                </div>
                <br><br>
                <div class="mb-3">
                  <label for="yearSelect" class="form-label" style="padding-right: 10px;">Select Year to get list of kids moving up class</label>
                  <select id="yearSelect" class="form-select" v-model="selectedYear" @change="fetchLevelUpList">
                    <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
                  </select>
                </div>
                <div v-if="loading">Loading...</div>
                <div v-else>
                  <div v-if="levelUpList.length === 0" class="alert alert-info">No data found for this year.</div>
                  <div v-else>
                    <div v-for="kid in levelUpList" :key="kid.kid_name" class="card mb-2">
                      <div class="card-body">
                        <h5 class="card-title">{{ kid.kid_name }}</h5>
                        <p class="card-text">{{ kid.note_content }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
  </div>
</template>

<script>
import ikid from '@/services/ikid.js'
import alertmodal from '@/views/alert/modal.vue'
import EventBus from '@/eventBus'

export default {
  components: { alertmodal },
  data() {
    const currentYear = new Date().getFullYear();
    const startYear = 2025;
    return {
      loading: false,
      submitting: false,
      selectedYear: currentYear,
      yearOptions: Array.from({length: currentYear - startYear + 1}, (_, i) => startYear + i),
      levelUpList: []
    }
  },
  created() {
    this.fetchLevelUpList();
  },
  methods: {
    async fetchLevelUpList() {
      this.loading = true;
      try {
        const res = await ikid.getKidLevelUpList(this.selectedYear);
        this.levelUpList = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.levelUpList = [];
      }
      this.loading = false;
    },
    async submit() {
      this.submitting = true;
      try {
        // No class data to process
        const res = await ikid.kidLevelUp();
        EventBus.$emit('OPEN_MODAL_ALERT', { title: 'Info', mode: 'info', data: res.message || 'No message' });
        await this.fetchLevelUpList();
      } catch (e) {
        EventBus.$emit('OPEN_MODAL_ALERT', { title: 'Error', mode: 'danger', data: 'Error occurred' });
      }
      this.submitting = false;
    }
  }
}
</script>

<style scoped>
.card {
  margin-top: 20px;
}
</style>